import React from 'react';

import { LegacyText } from '@gogame/components';

export const Note = ({ bulk, unit, dimensionName }) => {
  return (
    <LegacyText style={{ padding: '0 16px 16px 16px' }}>
      NOTE{' '}
      {bulk
        ? `All of the selected ${dimensionName}s will be affected by the following change.`
        : `Changing the ${unit} of this ${dimensionName} will update the budget of every ad in this ${dimensionName}.`}
    </LegacyText>
  );
};

export default Note;
